import React from 'react';
import { Col } from 'reactstrap';
import { renderHTMLContent } from '../../../common/function';
function List(props) {
  const { headerIcon, headerContent, bodyContent, children, onClick, paddingBox } = props;
  return (
    <Col xs={12} sm='6' md='6' lg='4'>
      <div className='border_box' onClick={onClick}>
        <p className='border_box_title font-weight-bold'>
          {headerIcon ? <img src={headerIcon} alt='header Icon' width='30' /> : null}
          {renderHTMLContent(headerContent, 'span', 'ml-1')}
        </p>
        <div className={paddingBox || 'padding_box '}>
          {renderHTMLContent(bodyContent, 'div', 'view_question_height view_questionhtml margin_bottom_40 cfa_notes_view')}
          {children}
        </div>
      </div>
    </Col>
  );
}

export default List;



// WEBPACK FOOTER //
// ./src/views/ESG/QuestionBank/List.jsx